<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-02-10 19:01 -->
<!-- Description:  -->
<template>
  <form @submit.prevent="save()">
    <div class="mb-3">
      <label for="">Titulo</label>
      <input class="form-control" type="text" v-model="reg.title">
    </div>
    <div class="mb-3">
      <label for="">Modulo</label>
      <input class="form-control" type="text" v-model="reg.module">
    </div>
    <div class="mb-3">
      <label for="">Path</label>
      <input class="form-control" type="text" v-model="reg.path">
    </div>
    <div class="mb-3">
      <label for="">Tipo</label>
      <select class="custom-select" name="" id="" v-model="reg.type">
        <option value="I">Interno</option>
        <option value="E">Externo</option>
        <option value="M">Menu</option>
      </select>
    </div>
    <div class="mb-3">
      <label for="">Menu Padre</label>
      <input class="form-control" type="number" v-model="reg.menu_id">
    </div>
    <div class="mb-3">
      <label for="">Permiso</label>
      <PermissionSelectFromAll v-model="reg.permission_id"></PermissionSelectFromAll>
    </div>

    <button class="btn btn-primary" :disabled="sending" type="submit">Guardar</button>
  </form>
</template>
<script>
import AdminService from "../AdminService.js";
import PermissionSelectFromAll from "../permissions/PermissionSelectFromAll.vue";

const rules = {}


export default {
  name: "MenuForm",
  components: {
    PermissionSelectFromAll,
  },

  // directives

  props: {
    disabled: { default: false },
    content: {
      default: () => ({}),
    }
  },

  data: () => ({
    sending: false,
    saved: false,
    reg: {},
  }),

  computed: {
    errors() { return false; }
  },

  // watch: {},

  mounted() {
    if(this.content.id) {
      this.reg = this.content;
    }
  },

  methods: {
    async save() { 
      this.saved = false;
      this.sending = true;
      let res = await AdminService.saveMenu(this.reg);
      this.$emit("saved", res);
      this.sending = false;
      this.saved = true;
    },
    reset() { 
      this.sending =false;
    },
    setValue() {},
  }
};
</script>
<style scoped></style>

